module.exports = __webpack_public_path__ + "static/media/trigorasgado.457ffc22.png";